import React, { useEffect, useState, useMemo, useCallback } from "react";
import { FloatingBanner } from "../FloatingBanner/FloatingBanner";
import Cookies from "universal-cookie";

export const ConsentForm = ({ language, fb_event_id, external_id, is_realistic, value_eur, product_id }) => {
  const [decisionMade, setDecisionMade] = useState(true) // start with true to avoid flashing
  const cookies = useMemo(() => new Cookies(), []);

  const translations = {
    "es": {
          "message": "Usamos Cookies y otras tecnologías propias y de terceros para hacer funcionar de manera correcta y segura nuestra página web y personalizar su contenido. También las utilizamos para analizar la navegación de los usuarios y poder ajustar la publicidad a tus gustos y preferencias. Puedes aceptarlas todas, rechazarlas o elegir tu configuración pulsando los botones correspondientes. Para más información puedes consultar nuestra Política de Cookies.",
          "usage": "Uso de cookies",
          "accept_all": "Aceptar todas",
          "reject_all": "Rechazar todas",
          "cookies_config": "Configuración de cookies",
          "manage_cookies": "Gestionar las preferencias de consentimiento",
          "necessary_cookies": "Cookies estrictamente necesarias",
          "analysis_cookies": "Cookies de análisis",
          "allow_selection": "Permitir la selección"
        },
    "en": {
        "message": "We use cookies and other proprietary and third-party technologies to make our website function correctly and securely and to personalise its content. We also use them to analyse user browsing and to be able to adjust advertising to your tastes and preferences. You can accept them all, reject them or choose your configuration by clicking on the corresponding buttons. For more information you can consult our Cookies Policy.",
        "usage": "Cookies usage ",
        "accept_all": "Accept all",
        "reject_all": "Reject all",
        "cookies_config": "Cookies configuration",
        "manage_cookies": "Manage consent preferences",
        "necessary_cookies": "Strictly necessary cookies",
        "analysis_cookies": "Analytics cookies",
        "allow_selection": "Allow selection"
    },
    "fr": {
        "message": "We use cookies and other proprietary and third-party technologies to make our website function correctly and securely and to personalise its content. We also use them to analyse user browsing and to be able to adjust advertising to your tastes and preferences. You can accept them all, reject them or choose your configuration by clicking on the corresponding buttons. For more information you can consult our Cookies Policy.",
        "usage": "Cookies usage ",
        "accept_all": "Accept all",
        "reject_all": "Reject all",
        "cookies_config": "Cookies configuration",
        "manage_cookies": "Manage consent preferences",
        "necessary_cookies": "Strictly necessary cookies",
        "analysis_cookies": "Analytics cookies",
        "allow_selection": "Allow selection"
    },
    "pt": {
        "message": "We use cookies and other proprietary and third-party technologies to make our website function correctly and securely and to personalise its content. We also use them to analyse user browsing and to be able to adjust advertising to your tastes and preferences. You can accept them all, reject them or choose your configuration by clicking on the corresponding buttons. For more information you can consult our Cookies Policy.",
        "usage": "Cookies usage ",
        "accept_all": "Accept all",
        "reject_all": "Reject all",
        "cookies_config": "Cookies configuration",
        "manage_cookies": "Manage consent preferences",
        "necessary_cookies": "Strictly necessary cookies",
        "analysis_cookies": "Analytics cookies",
        "allow_selection": "Allow selection"
    },
    "ru": {
        "message": "Мы используем файлы cookie и другие собственные и сторонние технологии для корректной и безопасной работы нашего сайта и персонализации его содержимого. Мы также используем их для анализа поведения пользователей и настройки рекламы под ваши вкусы и предпочтения. Вы можете принять их все, отклонить все или выбрать настройки, нажав соответствующие кнопки. Дополнительную информацию можно найти в нашей Политике использования файлов cookie.",
        "usage": "Использование файлов cookie",
        "accept_all": "Принять все",
        "reject_all": "Отклонить все",
        "cookies_config": "Настройка файлов cookie",
        "manage_cookies": "Управление настройками согласия",
        "necessary_cookies": "Строго необходимые файлы cookie",
        "analysis_cookies": "Аналитические файлы cookie",
        "allow_selection": "Разрешить выбор"
    }
  };

  function gtag() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  }

  const sendConsent = useCallback((consent) => {

    gtag('js', new Date());
    gtag('config', 'G-2R84YMS710');
    gtag('consent', 'default', consent);

    if ( consent.analytics_storage == "granted" ) {

      console.info("Analytics_storage accepted.");

      //window.pintrk('load', '2614234833498', { em: '<user_email_address>' });
      //window.pintrk('page');

      window.fbq('init', '527309371985437', {external_id: external_id});

      //let content_type = "product";

      //if (is_realistic === true) {
      //  window.fbq('init', '654387767265069', {external_id: external_id});
      //  content_type = "product"
      //}
      
      //if (is_realistic === false) {
      //  window.fbq('init', '1169560038195794');
      //  content_type = "non-realistic";
      //}

      const event_parameters = {item_number: product_id, content_type: "product", currency: 'EUR', value: value_eur};

      window.fbq('track', 'PageView', {}, {eventID: fb_event_id});
      window.fbq('trackCustom', 'PageView-beginners', {}, {eventID: fb_event_id+'CUSTOM'});
      window.fbq('track', 'ViewContent', event_parameters, {eventID: fb_event_id + 'CV'});

      //alert("SENT PageView & ViewContent");
      //alert(JSON.stringify(event_parameters));

    }

  }, [is_realistic, fb_event_id, external_id, value_eur]);

  useEffect(() => {
    if (cookies.get("cookies_consent") !== undefined) {
      setDecisionMade(true);
    } else {
      setDecisionMade(false);
    }
  }, [cookies, setDecisionMade, sendConsent])

  const realHandleDecision = (consent) => {

    cookies.set("cookies_consent", consent, {
      expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
      path: "/",
      //domain: "localhost"
      domain: ".10masters.com"
    })

    window.consent_cookie = consent;

    sendConsent(consent);
    setDecisionMade(true);

  }

  const handleDecision = (outcome) => {

    const consent = {
      'ad_storage': outcome,
      'analytics_storage': outcome,
      'ad_user_data': outcome,
      'ad_personalization': outcome,
    };

    realHandleDecision(consent);

  }

  const handleCustomDecision = () => {

    const consent = {
      'ad_storage': "denied",
      'analytics_storage': document.getElementById('checkbox_cookies_analytics_storage').checked ? "granted" : "denied",
      'ad_user_data': "denied",
      'ad_personalization': "denied",
    };

    realHandleDecision(consent);

  }

  return (
    decisionMade ? (
      <></>
    ) : (
      <FloatingBanner
        allow_selection={translations[language]["allow_selection"]}
        necessary_cookies={translations[language]["necessary_cookies"]}
        analysis_cookies={translations[language]["analysis_cookies"]}
        manage_cookies={translations[language]["manage_cookies"]}
        cookies_config={translations[language]["cookies_config"]}
        message={translations[language]["message"]}
        header={translations[language]["header"]}
        acceptText={translations[language]["accept_all"]}
        denyText={translations[language]["reject_all"]}
        onAccept={
          () => {
            handleDecision("granted")
          }
        }
        onDeny={
          () => {
            handleDecision("denied")
          }
        }
        onAcceptCustom={
          () => {
            handleCustomDecision()
          }
        } />
    )
  )
}